import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchNetload } from './netloadAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchNetloadDataWithFilters = createAsyncThunk(
  'netload/fetchNetloadDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchNetload({ filter, options }); // Pass filters to the API
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const netloadrSlice = createSlice({
  name: 'netload',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchNetloadDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchNetloadDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchNetloadDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectNetloadData = (state) => state.netload.data;
export const selectNetloadStatus = (state) => state.netload.status;
export const selectNetloadError = (state) => state.netload.error;

export default netloadrSlice.reducer;
